import { MemCommonNodeType } from "@mem-labs/common-editor";
import type { Editor } from "@tiptap/core";

/**
 * Collect the `src` of every image node in the editor doc, deduped. Used on
 * note-open to feed historical external images into the optimistic-attachment
 * pipeline; the caller passes the result straight to
 * `createOptimisticExternalImageAttachments`, which filters to external HTTPS
 * URLs (so `data:` / Mem-hosted srcs collected here are dropped downstream).
 */
export const collectImageSrcsFromDoc = (doc: Editor["state"]["doc"]): string[] => {
  const srcs = new Set<string>();
  doc.descendants(node => {
    if (node.type.name !== MemCommonNodeType.Image) {
      return true;
    }
    const src = node.attrs?.src;
    if (typeof src === "string" && src.length > 0) {
      srcs.add(src);
    }
    return true;
  });
  return [...srcs];
};
